module.exports = __webpack_public_path__ + "img/tu01.8eeb42d0.jpg";